import makeStyles from "@material-ui/core/styles/makeStyles"
import React from "react"

interface ComponentProps {
    icon: string
}
const useStyles = makeStyles(() => ({
    icon: {
        width: "1.8em",
        height: "1.8em",
        "& img": {
            width: "100%",
        },
    },
}))
const Icon = (props: ComponentProps) => {
    const classes = useStyles()
    const { icon } = props
    return (
        <div className={classes.icon}>
            <img src={icon} alt="图标"/>
        </div>
    )
}

export default Icon
